import { useNavigate } from "react-router-dom";
import NoData from "../../assets/img/nodata_gray.svg"
import { useEffect, useState } from "react";
import { formatDate } from "../../helpers/commons";
import AppSpinner from "../elements/AppSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import useProductionData from "../../hooks/useProductionData";

const ProductionPage =()=>{
    const navigate = useNavigate();
    const { loadingData, productionData, getProductionData } = useProductionData();

    useEffect(() => {
        getProductionData();
    }, []);
  


    return (
        <div>
            <div className="card">
                <div className=" card-body min-h-half-screen">
                    <div className="flex">
                        <nav className="flex justify-between " aria-label="Breadcrumb">
                            <ol className="inline-flex items-center mb-3 sm:mb-0">
                                <li>
                                <div className="flex items-center">
                                    <h5 className=" card-title ">Production</h5>
                                </div>
                                </li>
                            
                            </ol>
                        </nav>
                        <div className="flex-grow flex justify-end">
                            <button onClick={()=> navigate("/create-production")}   type="button" className="prim-btn-2 mb-2">New Entry</button>
                        </div>
                    </div>
                    
                    {
                         (productionData.length===0 && loadingData ==false)&&
                         <div  className=" h-fit flex-grow flex flex-col justify-center ">
                         <div className="flex justify-center">
                             <div>
                                 <img className=" w-32" src={NoData} alt=""  />
                                 <p>No Records Yet!</p>
                             </div>
                         </div>
                       </div>
                    }
                   {(loadingData)&& <AppSpinner/>}

                   {(productionData.length>0 )&&
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead>
                            <tr>
                                <th scope="col" >
                                    Value Chain
                                </th>
                                <th scope="col" >
                                    Year
                                </th>
                                <th scope="col" >
                                    Created
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                productionData.map((item,key)=>
                                    <tr key={key}>
                                        <td>{item.value_chain}
                                        </td>
                                        <td>{item.year}</td>
                                        <td>{ (item.created_at)&&formatDate(item.created_at,"MMM DD, YYYY H:mm")}</td>
                                        <td>
                                                <span onClick={() => navigate("/edit-production/" + item._id)} className=" cursor-pointer">
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </span>
                                            </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                   }
                  

                </div>
            </div>
        </div>
    )
}

export default ProductionPage;